import { render, staticRenderFns } from "./Reels.vue?vue&type=template&id=6508a556&scoped=true&lang=pug&"
import script from "./Reels.vue?vue&type=script&lang=js&"
export * from "./Reels.vue?vue&type=script&lang=js&"
import style0 from "./Reels.vue?vue&type=style&index=0&id=6508a556&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6508a556",
  null
  
)

export default component.exports